const COMMON = {
  ASIA_BANGKOK_TIMEZONE: 'Asia/Bangkok',
}

export default COMMON
